// Locale-prefixed page URLs (docs/i18n.md, "Locale-prefixed URLs"): every
// locale but English has a path prefix, /ja/player/..., and links from a
// prefixed page keep it. views/web/layout/flatlab.php prints the page's prefix
// locale (empty when unprefixed) and every prefix locale on <html>.
// services\i18n\UrlLocale is the PHP side.

// Paths with these extensions are files, not pages, and never take a prefix.
const STATIC_FILE = /\.(png|jpe?g|gif|svg|webp|ico|css|scss|map|js|jsx|json|xml|txt|woff2?|ttf|otf|mp3|ogg|wav|mp4|webm|html?|pdf|zip|exe|dmg|apk)$/i;

function defaultDocument() {
	return typeof document === 'undefined' ? null : document;
}

export function readUrlLocale(rootDocument = defaultDocument()) {
	const html = rootDocument && rootDocument.documentElement;
	if(!html) {
		return { locale: null, locales: [] };
	}
	return {
		locale: html.getAttribute('data-url-locale') || null,
		locales: (html.getAttribute('data-url-locales') || '').split(/\s+/).filter(Boolean),
	};
}

function prefixLocaleOf(pathname, locales) {
	const first = pathname.replace(/^\/+/, '').split('/')[0];
	return locales.includes(first) ? first : null;
}

// The path without its locale prefix: /ja/player/1 is /player/1, /ja is /.
export function stripLocalePrefix(pathname, locales = readUrlLocale().locales) {
	const locale = prefixLocaleOf(pathname, locales);
	if(!locale) {
		return pathname;
	}
	const rest = pathname.replace(/^\/+/, '').slice(locale.length);
	return rest === '' ? '/' : rest;
}

// href with the page's locale prefix when it is an unprefixed page on this
// site; anything else (another site, a file, a URL already in a locale, or any
// URL on an unprefixed page) comes back as it was.
export function localizeUrl(href, { origin, locale, locales }) {
	if(!locale || !locales.includes(locale)) {
		return href;
	}
	let url;
	try {
		url = new URL(href, origin);
	}
	catch(error) {
		return href;
	}
	if(url.origin !== origin || STATIC_FILE.test(url.pathname) || prefixLocaleOf(url.pathname, locales)) {
		return href;
	}
	url.pathname = `/${locale}${url.pathname === '/' ? '/' : url.pathname}`;
	return url.href;
}

// localizeUrl for this page's locale.
export function localizePageUrl(href, rootWindow = typeof window === 'undefined' ? null : window) {
	if(!rootWindow) {
		return href;
	}
	return localizeUrl(href, { origin: rootWindow.location.origin, ...readUrlLocale(rootWindow.document) });
}
